define('vspot-angular/resources/job-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        return $resource('/api/jobs/:controller:id',
            {
                id: '@id',
                controller: '@controller'
            },
            {
                get: {
                    method: 'GET'
                }
            }
        );
    }];
});
